import { APP_TOUR_STORAGE_KEY, APP_TOUR_VERSION } from './constants';
import type { AppTourState, TourStatus } from './types';

const DEFAULT_STATE: AppTourState = {
  version: APP_TOUR_VERSION,
  status: null,
};

function parseState(raw: string | null): AppTourState {
  if (!raw) {
    return { ...DEFAULT_STATE };
  }

  try {
    const parsed = JSON.parse(raw) as Partial<AppTourState>;
    return {
      version: typeof parsed.version === 'number' ? parsed.version : 0,
      status:
        parsed.status === 'completed' || parsed.status === 'skipped'
          ? parsed.status
          : null,
    };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

export function getTourState(): AppTourState {
  if (typeof window === 'undefined') {
    return { ...DEFAULT_STATE };
  }
  return parseState(localStorage.getItem(APP_TOUR_STORAGE_KEY));
}

export function setTourStatus(status: TourStatus): void {
  if (typeof window === 'undefined') {
    return;
  }
  const state: AppTourState = {
    version: APP_TOUR_VERSION,
    status,
  };
  localStorage.setItem(APP_TOUR_STORAGE_KEY, JSON.stringify(state));
}

export function resetTourState(): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.removeItem(APP_TOUR_STORAGE_KEY);
}

export function shouldAutoShowTour(): boolean {
  const state = getTourState();
  if (state.version < APP_TOUR_VERSION) {
    return true;
  }
  return state.status === null;
}
